import { SpecialsEvent } from '../../types';
import { bell, Icon, IconShape, lock } from '../Icon/Icon';
import './EventRow.css';

type EventRowProps = {
	id: number;
	title: string;
	message: string;
	type: SpecialsEvent;
};
export const EventRow = ({ title, message, type }: EventRowProps) => {
	let icon: IconShape = bell;
	switch (type) {
		case '':
			icon = bell;
			break;
		case 'locked':
			icon = lock;
			break;
		default:
			icon = bell;
			break;
	}
	return (
		<div className="event-item">
			<div className="event-icon">
				<div>
					<Icon shape={icon} size={32} />
				</div>
			</div>
			<div className="event-info">
				<div>
					<h3 className="title">{title}</h3>
					<p className="text">{message}</p>
				</div>
			</div>
		</div>
	);
};
